// Конфигурация интеграций для GameDev Studio
export const INTEGRATIONS = {
  // === АНАЛИТИКА ===
  YANDEX_METRICA: {
    COUNTER_ID: 0,
    ENABLED: false,
    CONFIG: {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    }
  },

  GOOGLE_ANALYTICS: {
    MEASUREMENT_ID: '',
    ENABLED: false,
  },

  // === СОЦИАЛЬНЫЕ СЕТИ И МЕССЕНДЖЕРЫ ===
  TELEGRAM: {
    BOT_TOKEN: '',
    CHAT_ID: '',
    ENABLED: false
  },

  DISCORD: {
    WEBHOOK_URL: '',
    ENABLED: false
  },

  // === EMAIL ===
  EMAIL: {
    CONTACT_EMAIL: 'contact@gamedev.studio',
    ENABLED: false
  },

  // === МАРКЕТИНГ И РЕКЛАМА ===
  FACEBOOK_PIXEL: {
    PIXEL_ID: '',
    ENABLED: false
  },

  GOOGLE_ADS: {
    CONVERSION_ID: '',
    ENABLED: false
  },

  // === ПЛАТЕЖИ ===
  STRIPE: {
    PUBLISHABLE_KEY: '',
    ENABLED: false
  },

  // === SEO И ИНДЕКСАЦИЯ ===
  GOOGLE_SEARCH_CONSOLE: {
    VERIFICATION_CODE: '',
    ENABLED: false
  },
};

// === ТИПЫ ДЛЯ ФОРМ ===
export interface ContactFormData {
  name: string;
  email: string;
  message: string;
}

// === ФУНКЦИИ ИНИЦИАЛИЗАЦИИ ===
export const initYandexMetrica = () => {
  if (!INTEGRATIONS.YANDEX_METRICA.ENABLED || !INTEGRATIONS.YANDEX_METRICA.COUNTER_ID) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = `
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(${INTEGRATIONS.YANDEX_METRICA.COUNTER_ID}, "init", ${JSON.stringify(INTEGRATIONS.YANDEX_METRICA.CONFIG)});
  `;
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${INTEGRATIONS.YANDEX_METRICA.COUNTER_ID}" style="position:absolute; left:-9999px;" alt="" /></div>`;
  document.body.appendChild(noscript);
};

export const initGoogleAnalytics = () => {
  if (!INTEGRATIONS.GOOGLE_ANALYTICS.ENABLED || !INTEGRATIONS.GOOGLE_ANALYTICS.MEASUREMENT_ID) return;

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${INTEGRATIONS.GOOGLE_ANALYTICS.MEASUREMENT_ID}`;
  document.head.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer?.push(args);
  }
  (window as any).gtag = gtag;
  gtag('js', new Date());
  gtag('config', INTEGRATIONS.GOOGLE_ANALYTICS.MEASUREMENT_ID);
};

export const initFacebookPixel = () => {
  if (!INTEGRATIONS.FACEBOOK_PIXEL.ENABLED || !INTEGRATIONS.FACEBOOK_PIXEL.PIXEL_ID) return;

  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${INTEGRATIONS.FACEBOOK_PIXEL.PIXEL_ID}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
};

// Инициализация всех активных интеграций
export const initAllIntegrations = () => {
  initYandexMetrica();
  initGoogleAnalytics();
  initFacebookPixel();
  
  console.log('🚀 Все активные интеграции инициализированы');
};

// === ПОЛЕЗНЫЕ ФУНКЦИИ ===
export const trackEvent = (eventName: string, params?: any) => {
  if (INTEGRATIONS.YANDEX_METRICA.ENABLED && (window as any).ym) {
    (window as any).ym(INTEGRATIONS.YANDEX_METRICA.COUNTER_ID, 'reachGoal', eventName, params);
  }
  
  if (INTEGRATIONS.GOOGLE_ANALYTICS.ENABLED && (window as any).gtag) {
    (window as any).gtag('event', eventName, params);
  }
};

// Глобальные типы
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    ym?: (...args: any[]) => void;
    dataLayer?: any[];
    fbq?: (...args: any[]) => void;
  }
}
